<template>
    <div class="servicedetail">
        <div class="tools_desp">
            <div class="info">
                <div>{{name === '星球' ? '星球' : name === '分销' ? '全民分销' : name === '拼购' ? '社群拼购' : name === '助力' ? '全民助力' : '一元购'}}</div>
                <div>{{name === '星球' ? despList.star : name === '分销' ? despList.distribution : name === '拼购' ? despList.salesgroup : name === '助力' ? despList.assist : ''}}</div>
                <div>¥{{price}}/年</div>
            </div>
            <div class="order_btn" @click="toOrder(name)">立即开通</div>
        </div>
        <div class="img">
            <img :src="name === '星球' ? imgList.star : name === '分销' ? imgList.distribution : name === '拼购' ? imgList.salesgroup : name === '助力' ? imgList.assist : ''">
        </div>
    </div>
</template>

<script>
import {savePriceBuyInfo} from '@/api/orderService'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'serviceDetail',
    data() {
        return {
            name: this.$route.query.modulename,
            price: this.$route.query.modulemoney,
            imgList: {
                star: require('@/common/images/service/img_1.png'),
                assist: require('@/common/images/service/img_4.png'),
                // salesone: require('@/common/images/service/img_1.png'),
                salesgroup: require('@/common/images/service/img_3.png'),
                distribution: require('@/common/images/service/img_2.png'),
            },
            despList: {
                star: '组合打包不同课程、设置会员优惠价格，一次购买，在权限时长内可以学习所有课程。',
                assist: '组合打包不同课程、设置会员优惠价格，一次购买，在权限时长内可以学习所有课程。',
                salesgroup: '组合打包不同课程、设置会员优惠价格，一次购买，在权限时长内可以学习所有课程。',
                distribution: '组合打包不同课程、设置会员优惠价格，一次购买，在权限时长内可以学习所有课程。'
            }
        }
    },
    mounted() {
        
    },
    methods: {
        // 立即开通
        toOrder(type) {
            type = type === '星球' ? '2' : type === '分销' ? '3' : type === '拼购' ? '4' : type === '1元购' ? '5' : '助力' ? '6' : ''
            let data = {
                moduletype: type,
            }
            this.setLoading(true)
            savePriceBuyInfo({
                data: data,
                success: data => {
                    this.setLoading(false)
                    this.orderno = data.data.orderno
                    if (data.data.ispaysuccess === 2) {
                        this.$router.push({name: 'orderConfirm', query: {'orderno': data.data.orderno}})
                    } else {
                        window.location = data.data.url
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },

        ...mapActions ([
            'setLoading'
        ])
    }
}
</script>

<style lang="scss">
.flex {
    display: flex;
}
.servicedetail {
    .tools_desp {
        padding: 20px;
        height: 140px;
        background: #fff;
        .info {
            div:nth-child(1) {
                font-size: 24px;
                color: #303133;
            }
            div:nth-child(2) {
                font-size: 14px;
                color: #606266;
                margin: 10px 0;
            }
            div:nth-child(3) {
                font-size: 16px;
                color: #409EFF;
            }
        }
        .order_btn {
            width: 96px;
            height: 32px;
            background: #409EFF;
            color: #fff;
            line-height: 32px;
            text-align: center;
            border-radius: 4px;
            font-size: 14px;
            margin-top: 25px;
            cursor: pointer;
        }
    }
    .img {
        background: #fff;
        margin-top: 20px;
        padding: 20px;
        img {
            display: inline-block;
            width: 1640px;
            height: 915px;
        }
    }
}
</style>
